import * as types from './mutation-types';

export default {
  [types.SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [types.SET_EVENTS](state, events) {
    state.events = events;
  },
  [types.SET_SERVICES](state, services) {
    state.services = services;
  },
  [types.SET_MENUS](state, menus) {
    state.menus = menus;
  },
  [types.SET_OPEN_MENU](state, openMenu) {
    state.openMenu = openMenu;
  },
  [types.SET_DEFAULT_ROUTER](state, defaultRoute) {
    state.defaultRoute = defaultRoute;
  },
  [types.SET_TOGGLE_MENU](state, toggleMenu) {
    state.toggleMenu = toggleMenu;
  },
  [types.SET_SHOW_NOTIFICATIONS](state, showNotifications) {
    state.showNotifications = showNotifications;
  },
  [types.SET_USER_COLLECTION](state, payload) {
    state.userCollection = payload;
  },
};
